module.exports = __webpack_public_path__ + "static/img/next.5f5d0d19.png";